let _tickAnimationImpl = null;
function _setTickAnimationImpl(impl) {
  _tickAnimationImpl = impl;
}
function tickAnimation(group, deltaMs, engine) {
  _tickAnimationImpl?.(group, deltaMs, engine);
}

export { _setTickAnimationImpl, tickAnimation };
//# sourceMappingURL=animation-tick.js.map
